export default {"src":"/_next/static/media/search-outline-icon.53df1c00.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};